import React from 'react';
import styled, { css } from 'styled-components';
import withBuyButton from '@catalogo/service-americanas-product/src/hocs/buy-button';
import { Nav } from '@catalogo/core-nav';
import Icon from './components/icon';

export const BuyButton = ({
  isInternational,
  fullWidth,
  buyButtonText,
  showPreSaleButton,
  sendMetrics,
  handleAddProduct,
}) =>
  showPreSaleButton ? (
    <PreSaleButton onClick={handleAddProduct} id="buy-button" className="pre-sale-button" $fullWidth={fullWidth}>
      <Icon isInternational={isInternational} />
      <div className="pre-sale-text">
        <span>comprar na</span>
        <strong> pré-venda</strong>
      </div>
    </PreSaleButton>
  ) : (
    <ButtonUI id="buy-button" className="buy-button" $fullWidth={fullWidth} onClick={sendMetrics}>
      <Icon isInternational={isInternational} />
      <BuyButtonText className="buy-button-text" $fullWidth={fullWidth}>
        {buyButtonText}
      </BuyButtonText>
    </ButtonUI>
  );

const BuyButtonText = styled.span`
  font-size: ${({ $fullWidth }) => ($fullWidth ? '20px' : '16px')};
  font-weight: bold;
  color: #fff;
  margin-top: -3px;
`;

const styledButton = css`
  background: ${({ theme }) => theme.primaryColor};
  text-decoration: none;
  display: flex;
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '48%')};
`;

const ButtonUI = styled(Nav)`
  ${styledButton}
  border-radius: 12px;
  height: ${({ $fullWidth }) => ($fullWidth ? '54px' : '44px')};
  padding: ${({ $fullWidth }) => ($fullWidth ? '15px 12px' : '10px 12px')};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '175px')};
  cursor: pointer;

  @media (min-width: 660px) {
    width: 328px;
    margin: 0px auto;
  }
`;

const PreSaleButton = styled(Nav)`
  ${styledButton}
  padding: ${({ $fullWidth }) => ($fullWidth ? '15px 12px' : '5px 12px')};
  height: ${({ $fullWidth }) => ($fullWidth ? '54px' : '44px')};
  color: ${({ theme }) => theme.white};
  border-radius: 12px;

  @media (min-width: 660px) {
    width: 300px;
    margin: 0px auto;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    strong {
      font-size: 16px;
    }
  }
`;

PreSaleButton.displayName = 'PreSaleButton';

export default withBuyButton(BuyButton);
